/* Copie klikcamera.com : cartes produit (défilement des photos, vignettes de couleur, achat rapide, grille/liste). */
(function () {
  if (window.KCCards) return;

  function loadImg(el) {
    var img = el && el.querySelector('img[data-src]');
    if (img) {
      img.src = img.getAttribute('data-src');
      if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
  }

  function setIndex(card, idx) {
    var media = card.querySelector('.kc-card__media');
    var imgs = card.querySelectorAll('.kc-card__img');
    if (!imgs.length) return;
    idx = (idx + imgs.length) % imgs.length;
    imgs.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
    loadImg(imgs[idx]);
    loadImg(imgs[(idx + 1) % imgs.length]);
    media.classList.add('is-paged');
    card.setAttribute('data-index', idx);
    var dots = card.querySelectorAll('.kc-card__dot');
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === (idx === 0 ? 0 : 1)); });
  }

  document.addEventListener('click', function (e) {
    var pageBtn = e.target.closest('[data-kc-page]');
    if (pageBtn) {
      e.preventDefault();
      var card = pageBtn.closest('[data-kc-card]');
      var cur = parseInt(card.getAttribute('data-index') || '0', 10);
      var media = card.querySelector('.kc-card__media');
      // au premier clic sur « suivant », on part de l'image affichée au survol
      if (!media.classList.contains('is-paged') && window.matchMedia('(min-width: 960px)').matches && media.matches(':hover') && card.querySelector('.kc-card__img.is-hover')) cur = 1;
      setIndex(card, cur + parseInt(pageBtn.getAttribute('data-kc-page'), 10));
      return;
    }
    var qb = e.target.closest('[data-kc-quickbuy]');
    if (qb && window.matchMedia('(min-width: 768px)').matches) {
      e.preventDefault();
      openQuickbuy(qb.closest('[data-kc-card]'));
      return;
    }
    var close = e.target.closest('[data-kc-qb-close]');
    if (close) { e.preventDefault(); closeQuickbuy(close.closest('.kc-qb-row')); return; }
    var sw = e.target.closest('.kc-qb__thumb');
    if (sw) { e.preventDefault(); showQbImage(sw.closest('.kc-qb'), sw.getAttribute('data-src'), sw); return; }
    var layout = e.target.closest('[data-kc-layout]');
    if (layout) {
      e.preventDefault();
      var grid = document.getElementById(layout.getAttribute('aria-controls'));
      if (!grid) return;
      var list = layout.getAttribute('data-kc-layout') === 'list';
      grid.classList.toggle('is-list', list);
      layout.parentElement.querySelectorAll('[data-kc-layout]').forEach(function (b) { b.classList.toggle('is-active', b === layout); b.setAttribute('aria-pressed', b === layout); });
    }
  });

  // vignettes de couleur : au survol, la photo de la carte prend la couleur survolée
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.kc-card__swatch[data-media-id]');
    if (!sw) return;
    var card = sw.closest('[data-kc-card]');
    var target = card.querySelector('.kc-card__img[data-media-id="' + sw.getAttribute('data-media-id') + '"]');
    if (target) { setIndex(card, parseInt(target.getAttribute('data-index'), 10)); return; }
    var primary = card.querySelector('.kc-card__img.is-primary img');
    if (primary) { primary.srcset = ''; primary.src = sw.getAttribute('data-img'); setIndex(card, 0); }
  });

  /* ---------- Achat rapide ---------- */
  function rowEnd(item) {
    var parent = item.parentElement;
    var items = Array.prototype.filter.call(parent.children, function (c) { return !c.classList.contains('kc-qb-row') && c.offsetParent !== null; });
    var top = item.offsetTop;
    var last = item;
    items.forEach(function (c) { if (Math.abs(c.offsetTop - top) < 4) last = c; });
    return last;
  }

  function closeQuickbuy(row, cb) {
    if (!row) { if (cb) cb(); return; }
    var wrap = row.querySelector('.kc-qb-row__wrap');
    wrap.style.height = wrap.scrollHeight + 'px';
    requestAnimationFrame(function () { wrap.style.height = '0px'; });
    setTimeout(function () { row.remove(); if (cb) cb(); }, 700);
  }

  function openQuickbuy(card) {
    if (!card) return;
    var item = card.closest('li') || card.parentElement;
    if (!item || !item.parentElement) { window.location.href = card.getAttribute('data-url'); return; }
    var existing = item.parentElement.querySelector(':scope > .kc-qb-row');
    if (existing && existing.getAttribute('data-handle') === card.getAttribute('data-handle')) { closeQuickbuy(existing); return; }
    var url = card.getAttribute('data-url');
    var go = function () {
      var end = rowEnd(item);
      var row = document.createElement(item.tagName === 'LI' ? 'li' : 'div');
      row.className = 'kc-qb-row';
      row.setAttribute('data-handle', card.getAttribute('data-handle'));
      row.innerHTML = '<div class="kc-qb-row__wrap"><button type="button" class="kc-qb-row__close" data-kc-qb-close aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg></button><div class="kc-qb-row__content"></div></div>';
      end.after(row);
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=kc-quickbuy')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var qb = doc.querySelector('.kc-qb');
          if (!qb) { window.location.href = url; return; }
          var content = row.querySelector('.kc-qb-row__content');
          content.appendChild(qb);
          initQb(qb);
          var wrap = row.querySelector('.kc-qb-row__wrap');
          requestAnimationFrame(function () {
            wrap.style.height = wrap.scrollHeight + 'px';
            setTimeout(function () { wrap.style.height = 'auto'; }, 720);
          });
        })
        .catch(function () { window.location.href = url; });
    };
    if (existing) closeQuickbuy(existing, go); else go();
  }

  function showQbImage(qb, src, thumb) {
    var main = qb.querySelector('.kc-qb__main img');
    if (main && src) { main.srcset = ''; main.src = src; }
    qb.querySelectorAll('.kc-qb__thumb').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  }

  function initQb(qb) {
    var dataEl = qb.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = qb.querySelector('form');
    var price = qb.querySelector('.kc-qb__price');
    var btn = qb.querySelector('.kc-qb__atc');
    var err = qb.querySelector('.kc-qb__error');
    function selected() {
      return Array.prototype.map.call(qb.querySelectorAll('.kc-qb__option'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function update() {
      var opts = selected();
      // Produit sans option affichée (variante unique « Default Title », ex. les étuis) : on prend la seule variante.
      var v = opts.length === 0 ? data.variants[0]
        : data.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      qb.querySelectorAll('.kc-qb__option').forEach(function (fs, i) {
        var lab = fs.querySelector('legend span'); var c = fs.querySelector('input:checked');
        if (lab && c) lab.textContent = c.value;
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var ok = data.variants.some(function (x) { return x.available && x.options.every(function (o, j) { return o === test[j]; }); });
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!v) { btn.disabled = true; btn.textContent = data.t_unavailable; return; }
      form.querySelector('[name="id"]').value = v.id;
      var html = '<span class="kc-card__current">' + KC.money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) html += '<span class="kc-card__was">' + KC.money(v.compare_at_price) + '</span>';
      price.innerHTML = html;
      btn.disabled = !v.available;
      btn.textContent = v.available ? data.t_add : data.t_soldout;
      if (v.image) showQbImage(qb, v.image, null);
    }
    qb.addEventListener('change', function (e) { if (e.target.closest('.kc-qb__option')) update(); });
    update();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!window.KC || !KC.cart) { form.submit(); return; }
      btn.disabled = true; err.classList.remove('is-visible');
      KC.cart.add([{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }])
        .then(function () { btn.disabled = false; closeQuickbuy(qb.closest('.kc-qb-row')); })
        .catch(function (x) { btn.disabled = false; err.textContent = (x && (x.description || x.message)) || data.t_error; err.classList.add('is-visible'); });
    });
  }

  window.KCCards = { open: openQuickbuy };
})();
